import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useState, useRef } from 'react';
import i18n from 'i18next';
import cx from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';
import DataTable from '../ui/table'; // api

import { getTrafficEventListPublished } from '../../api/eventAPI'; // redux

import { setEventTableList, setEventTableSort } from '../../redux/traffic-prediction';
var t = i18n.getFixedT(null, 'traffic-prediction');
var MapAnalyticsTable = /*#__PURE__*/React.memo(function (props) {
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      _useSelector$trafficP = _useSelector.trafficPrediction,
      eventTableList = _useSelector$trafficP.eventTableList,
      eventTableSort = _useSelector$trafficP.eventTableSort;

  var dispatch = useDispatch();
  var isMounted = useRef(false);
  var isShowTable = props.isShowTable;
  useEffect(function () {
    if (isMounted.current) {
      getTrafficEventListPublished(contextRoot, false, '', eventTableSort, 0, null).then(function (result) {
        var now = moment().valueOf();

        var eventData = _.filter(result.content, function (el) {
          if (_.isEmpty(el.endTime)) return true;
          var endTime = moment(el.endTime).valueOf();
          return endTime > now;
        });

        var events = _.map(eventData, function (el, index) {
          return _objectSpread(_objectSpread({}, el), {}, {
            sequence: index + 1
          });
        });

        dispatch(setEventTableList(events));
      });
    }
  }, [JSON.stringify(eventTableSort)]);
  useEffect(function () {
    if (!isMounted.current) isMounted.current = true;
  }, []);

  var handleSort = function handleSort(sort) {
    dispatch(setEventTableSort(sort));
  };

  var handleSplitTime = function handleSplitTime(time) {
    if (_.isEmpty(time)) return time;
    var timeAry = time.split(' ');
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, timeAry[0]), /*#__PURE__*/React.createElement("div", null, timeAry[1]));
  };

  var fields = {};

  _.set(fields, 'sequence', {
    label: t('lbl-sequence')
  });

  _.set(fields, 'type', {
    label: t('lbl-event-type'),
    formatter: function formatter(val, row) {
      return /*#__PURE__*/React.createElement("div", {
        title: val,
        onClick: function onClick() {
          return handleOpenDialog(row);
        }
      }, val);
    }
  });

  _.set(fields, 'beginTime', {
    label: t('lbl-released-time'),
    sortable: true,
    formatter: function formatter(val) {
      return handleSplitTime(val);
    }
  });

  _.set(fields, 'source', {
    label: t('lbl-source')
  });

  return /*#__PURE__*/React.createElement("div", {
    className: cx('mapAnalytics-table', {
      'hideTable': !isShowTable
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "table-head"
  }, /*#__PURE__*/React.createElement("span", {
    className: "title"
  }, t('lbl-event-list'))), /*#__PURE__*/React.createElement("div", {
    className: "c-border c-position-rlt dataTable-wrap"
  }, /*#__PURE__*/React.createElement(DataTable, {
    fields: fields,
    data: eventTableList,
    sort: eventTableSort,
    onSort: handleSort
  })));
});
export default MapAnalyticsTable;